import { FC } from "react";
import { Dayjs } from "dayjs";

type Props = {
  date: Dayjs;
};

const Heading: FC<Props> = ({ date, ...rest }) => {
  return (
    <div
      {...rest}
      className={
        "not-italic font-semibold text-2xl leading-[99.5%] text-white capitalize items-center grid grid-cols-[190px_20px] gap-4"
      }
    >
      {date.format("MMMM")}&nbsp;
      {date.format("YYYY")}
    </div>
  );
};

export default Heading;
